import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IhmWarningMessageLevel } from './ihm-warning-message.enum';

@Component({
  selector: 'app-ihm-warning-message',
  templateUrl: './ihm-warning-message.component.html',
  styleUrls: ['./ihm-warning-message.component.scss']
})
export class IhmWarningMessageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
  // Inputs
  @Input() readonly message: string;
  @Input() readonly secondaryMessages: string[];
  @Input() readonly dismissible: boolean;

  // if not show on Click, message is displayed next to the icon
  @Input() readonly showOnClick: boolean;
  @Input() readonly isResponsive: boolean = false;

  @Input() readonly level: IhmWarningMessageLevel = IhmWarningMessageLevel.INFO;

  @Output() readonly messageDismissed: EventEmitter<void> = new EventEmitter<void>();

  public dismissMessage(): void {
    this.messageDismissed.emit();
  }
}
